import type { ColGroupDef } from 'ag-grid-community'

import AnalyticsKpisBuilder from '../AnalyticsKpisBuilder'
import { formatPercent } from '../utils'

export const uaEroiPercentDefs: ColGroupDef = {
  children: [
    {
      aggFunc: 'uaEroipercentd30Avg',
      field: 'ua_eroi_percent_d30',
      headerName: 'D30',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'uaEroipercentd10Avg',
      field: 'ua_eroi_percent_d10',
      headerName: 'D10',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'uaEroipercentd7Avg',
      field: 'ua_eroi_percent_d7',
      headerName: 'D7',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'uaEroipercentd3Avg',
      field: 'ua_eroi_percent_d3',
      headerName: 'D3',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
    {
      aggFunc: 'uaEroipercentd0Avg',
      field: 'ua_eroi_percent_d0',
      headerName: 'D0',
      type: 'numericColumn',
      valueFormatter: formatPercent,
      valueGetter: AnalyticsKpisBuilder.buildKpi,
    },
  ],
  headerClass: 'lightGreyFill',
  headerName: 'UA eROI %',
}
